<template>
  <div class="parking-reduction-page">
    <div class="nav-header">
      <i class="el-icon-arrow-left" @click="$router.back()"></i>
      <span class="title">停车减免</span>
      <div class="placeholder"></div>
    </div>

    <div class="station-section">
      <div class="station-card">
        <span>{{ currentStation }}</span>
        <i class="el-icon-sort rotate-90"></i>
      </div>
    </div>

    <div class="analysis-section">
      <div class="card-main">
        <div class="card-header">
          <div class="title-left">
            <span class="vertical-bar"></span>
            <span class="text">减免分析</span>
          </div>
          <div class="time-select">
            近7天 <i class="el-icon-arrow-down"></i>
          </div>
        </div>

        <div class="metrics-grid">
          <div class="metric-box">
            <p class="label">减免成功率 <i class="el-icon-question"></i></p>
            <p class="value">{{ statsData.successRate || '-' }}</p>
          </div>
          <div class="metric-box">
            <p class="label">减免订单数 <i class="el-icon-question"></i></p>
            <div class="value-row">
              <span class="value">{{ statsData.reduceCount || '0' }}</span>
            </div>
          </div>
          <div class="metric-box">
            <p class="label">用户申诉数 <i class="el-icon-question"></i></p>
            <p class="value">{{ statsData.appealCount || '0' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="tools-section">
      <div class="section-header">
        <span class="vertical-bar"></span>
        <span class="text">管理工具</span>
      </div>
      <div class="tool-card">
        <div class="tool-item" @click="goAppeal">
          <div class="item-top">
            <span class="label">停车费申诉审核</span>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="item-bottom">
            <span class="count">{{ pendingAppealCount }}</span>
            <span class="sub-label">待审核</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { agentPlotList } from "@/api/newApi";

export default {
  name: 'ParkingReduction',
  data() {
    return {
      currentStation: '全部场站',
      statsData: {
        successRate: '-',
        reduceCount: '0',
        appealCount: '0'
      },
      pendingAppealCount: 0,
      stationList: []
    };
  },
  mounted() {
    this.getStationList();
  },
  methods: {
    async getStationList() {
      try {
        const res = await agentPlotList({});
        if (res.data && res.data.length > 0) {
          this.stationList = res.data;
        }
      } catch (err) {
        console.log('获取场站列表失败', err);
      }
    },
    goAppeal() {
      this.$router.push('/parking/appeal');
    }
  }
};
</script>

<style lang="scss" scoped>
.parking-reduction-page {
  background-color: #F7F9FC;
  min-height: 100vh;
  padding-bottom: 30px;
}

.nav-header {
  background: #FFF;
  padding: 15px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .title { font-size: 18px; font-weight: bold; }
  i { font-size: 20px; }
  .placeholder { width: 20px; }
}

.station-section {
  padding: 12px 16px;
  .station-card {
    background: #FFF;
    padding: 15px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    .rotate-90 { transform: rotate(90deg); color: #999; font-size: 14px; }
  }
}

.analysis-section {
  padding: 0 16px;
  .card-main {
    background: #FFF;
    border-radius: 12px;
    padding: 16px;
    min-height: 300px;
    display: flex;
    flex-direction: column;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .title-left {
        display: flex;
        align-items: center;
        .vertical-bar { width: 4px; height: 16px; background: #00BFA5; border-radius: 2px; margin-right: 8px; }
        .text { font-size: 17px; font-weight: bold; }
      }
      .time-select { font-size: 13px; color: #BBB; i { font-size: 12px; } }
    }
  }
}

.metrics-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  .metric-box {
    background: #F8FAFB;
    padding: 15px;
    border-radius: 8px;
    border: 1px solid transparent;
    .label { font-size: 12px; color: #999; margin-bottom: 10px; i { font-size: 13px; } }
    .value { font-size: 22px; font-weight: bold; color: #333; }
    .value-row {
      display: flex;
      align-items: baseline;
      gap: 8px;
      .trend {
        font-size: 12px;
        &.down { color: #52C41A; }
      }
    }
  }
}

.tools-section {
  padding: 20px 16px;
  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .vertical-bar { width: 4px; height: 16px; background: #00BFA5; border-radius: 2px; margin-right: 8px; }
    .text { font-size: 17px; font-weight: bold; }
  }
  .tool-card {
    background: #FFF;
    border-radius: 12px;
    padding: 16px;
    .tool-item {
      background: #F8FAFB;
      padding: 15px;
      border-radius: 8px;
      width: 180px;
      cursor: pointer;
      .item-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;
        .label { font-size: 13px; color: #333; }
        i { color: #CCC; font-size: 12px; }
      }
      .item-bottom {
        display: flex;
        flex-direction: column;
        .count { font-size: 24px; font-weight: bold; }
        .sub-label { font-size: 11px; color: #999; margin-top: 4px; }
      }
    }
  }
}
</style>